import { render } from "./BaseCard.vue?vue&type=template&id=bc17bc32&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=bc17bc32&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc17bc32"]])

export default __exports__